import * as React from 'react';

import { LogoMonogram } from '../../brand/logo-monogram';
import { LogoWordmark } from '../../brand/logo-wordmark';
import { cn } from '../../lib/cn';

export interface LogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'monogram' | 'wordmark';
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_MONOGRAM: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-5 w-5',
  md: 'h-7 w-7',
  lg: 'h-10 w-10',
};

const SIZE_WORDMARK: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-5',
  md: 'h-7',
  lg: 'h-10',
};

export const Logo = React.forwardRef<HTMLSpanElement, LogoProps>(
  ({ className, variant = 'wordmark', size = 'md', ...props }, ref) => {
    const dim = variant === 'monogram' ? SIZE_MONOGRAM[size] : SIZE_WORDMARK[size];
    return (
      <span
        ref={ref}
        className={cn('inline-flex items-center text-[var(--color-fg)]', className)}
        {...props}
      >
        {variant === 'monogram' ? (
          <LogoMonogram className={dim} />
        ) : (
          <LogoWordmark className={dim} />
        )}
      </span>
    );
  },
);
Logo.displayName = 'Logo';
